import request from './request';

// 事故距离统计-图表
export function getClueDistance(params) {
    return request('/stat/clue/distance/view', {
        method: 'POST',
        params,
    });
}

// 事故距离统计-列表
export function getClueDistanceList(params) {
    return request('/stat/clue/distance/list', {
        method: 'POST',
        params,
    });
}
